'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by zfc on 2016/7/28.
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoeasyRadio = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(GoeasyRadio, _Component);

  function GoeasyRadio() {
    (0, _classCallCheck3.default)(this, GoeasyRadio);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(GoeasyRadio).apply(this, arguments));
  }

  (0, _createClass3.default)(GoeasyRadio, [{
    key: 'analysisRadio',
    value: function analysisRadio() {
      var styles = require('./GoeasyInputField.scss');
      var _props = this.props;
      var Id = _props.Id;
      var currentData = _props.currentData;
      var fieldsType = _props.fieldsType;
      var customStyle = _props.customStyle;
      var page = _props.page;
      /*  let style = {marginBottom: '10px'};
       if (customStyle) {
       style = {...style, ...customStyle};
       }*/

      console.log(currentData);
      console.log(fieldsType);
      if (!fieldsType || fieldsType === '') {
        if (page === 'chooseItemImg') {
          return _react2.default.createElement(
            'div',
            { style: customStyle },
            _react2.default.createElement('input', { type: 'radio', id: Id, className: styles.inputRadio, value: currentData.value }),
            _react2.default.createElement('label', { className: styles.chooseLabel, htmlFor: Id }),
            _react2.default.createElement('img', { className: styles.chooseImg, src: currentData.img })
          );
        }
        /*
         if (page === 'personalOrCompany' || page === 'orderPreview') {
         return (<div key={currentData.value} style={style}>
         <input type="radio" id={Id} className={styles.inputRadio} value={currentData.value}/>
         <label htmlFor={Id}></label>
         <span className={styles.personalOrCompany}>{currentData.label || currentData.value}</span>
         </div>);
         }
         else if (page === 'isInvoiceWithExpress') {
         return (
         <div key={currentData} style={style}>
         <input type="checkbox" id={Id} className={styles.inputCheckbox} value={currentData} checked={isChecked}/>
         <label htmlFor={Id}></label>
         <span className={styles.isInvoiceWithExpressSpan}>是否需要发票</span>
         </div>);
         }*/
        return _react2.default.createElement(
          'div',
          { style: customStyle },
          _react2.default.createElement('input', { type: 'radio', id: Id, className: styles.inputRadio, value: currentData.value }),
          _react2.default.createElement('label', { htmlFor: Id }),
          _react2.default.createElement(
            'span',
            {
              className: page === 'personalOrCompany' || page === 'orderPreview' ? styles.personalOrCompany : styles.spanAfterRadio },
            currentData.label || currentData.value
          )
        );
      }

      /*    if (page === 'PackagingModal') {
       return (
       <div key={Id} className={styles.packagindModal}>
       <input type="radio" id={Id} {...fieldsType} className={styles.inputRadioFields}
       checked={Id === fieldsType.value} value={Id}/>
       <label htmlFor={Id}></label>
       <img src={currentData.img}/>{currentData.packagingDescribe + ':' + currentData.price}</div>
       );
       }*/
      return _react2.default.createElement(
        'div',
        { key: currentData.value, style: customStyle },
        _react2.default.createElement('input', (0, _extends3.default)({ type: 'radio', id: Id }, fieldsType, { className: styles.inputRadioFields, value: currentData.value,
          checked: currentData.value === fieldsType.value })),
        _react2.default.createElement('label', { htmlFor: Id }),
        _react2.default.createElement(
          'span',
          { className: styles.spanAfterRadioFields },
          currentData.label || currentData.value
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return this.analysisRadio();
    }
  }]);
  return GoeasyRadio;
}(_react.Component), _class.propTypes = {
  Id: _react.PropTypes.string,
  customStyle: _react.PropTypes.object,
  currentData: _react.PropTypes.object.isRequired,
  fieldsType: _react.PropTypes.object,
  page: _react.PropTypes.string,
  isChecked: _react.PropTypes.bool
}, _temp);
exports.default = GoeasyRadio;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/GoeasyInputField/GoeasyRadio.js
 ** module id = 129
 ** module chunks = 0
 **/